import noUiSlider from 'nouislider';
import moment from 'moment';
import { range } from 'lodash';

// Given a start date (YYYY-MM) find the number of months to another date
export const monthDiff = (from, to) => {
    const fromMoment = moment(from, 'YYYY-MM');
    const toMoment = moment(to, 'YYYY-MM');
    return Math.abs(fromMoment.diff(toMoment, 'months'));
};

// Returns an array of number for where to plot year pips
// assuming start is 0 and end is number of months in future
export const plotYears = (start, end) => {
    const startPoint = moment(start, 'YYYY-MM');
    const endPoint = moment(end, 'YYYY-MM');
    const yearRange = range(Number(startPoint.format('YYYY')), Number(endPoint.format('YYYY')) + 1);

    return yearRange.map((year, index) => {
        // If first or last number, return start or end of full range
        if (index === 0) return 0;
        // if (index === yearRange.length - 1) return monthDiff(startPoint, endPoint);

        return monthDiff(startPoint, year);
    });
};

const dateSlider = document.getElementById('slider');
const dateSliderLabel = document.getElementById('slider-label');

if (dateSlider && dateSliderLabel) {
    const rangeStart = dateSlider.dataset.rangeStart;
    const rangeEnd = dateSlider.dataset.rangeEnd;
    const filterStart = dateSlider.dataset.filterStart;
    const filterEnd = dateSlider.dataset.filterEnd;

    noUiSlider.create(dateSlider, {
        connect: true,
        step: 1,
        range: {
            min: 0,
            max: monthDiff(rangeStart, rangeEnd),
        },
        start: [monthDiff(rangeStart, filterStart), monthDiff(rangeStart, filterEnd)],
        pips: {
            mode: 'values',
            values: plotYears(rangeStart, rangeEnd),
            format: {
                to(value) {
                    return moment(rangeStart).add(value, 'month').format('YYYY');
                },
            },
        },
    });

    dateSlider.noUiSlider.on('update', (unencoded) => {
        const activeStart = moment(rangeStart).add(Number(unencoded[0]), 'month');
        const activeEnd = moment(rangeStart).add(Number(unencoded[1]), 'month');

        // Update labels
        const labelStart = activeStart.format('MMM YYYY');
        const labelEnd = activeEnd.format('MMM YYYY');
        dateSliderLabel.innerHTML = `${labelStart} &mdash; ${labelEnd}`;

        // Update input values
        const inputStart = activeStart.format('YYYY-MM');
        const inputEnd = activeEnd.format('YYYY-MM');
        document.getElementById('start-date').value = inputStart;
        document.getElementById('end-date').value = inputEnd;
    });
}
